import React, { useContext, useEffect, useState } from 'react'
import '../../../assets/styles/typography.scss'
import './index.scss'
import NavBar from '@Components/Navigations/NavBar'
import { Outlet, ScrollRestoration } from 'react-router'
import Footer from '@Components/Navigations/Footer'
import AlertMessage from '@Components/Popups/AlertMessage'
import Preloaders from '@Components/Preloaders'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import HelmetSet from '@Components/HelmetSet'
import { useErrorBoundary } from 'react-error-boundary'
import { axiosClient } from '@App/api/api-client'
import { HttpError } from '@App/exceptions/HttpError'
import UserInfoHandler from '@Scenes/RootLayout/UserInfoHandler'
import MLCThemeProvider from '@Scenes/RootLayout/MLCThemeProvider'
import useDatadogConsent from '@Scenes/RootLayout/hooks/use-datadog-consent'
import useSegmentConsent from '@Scenes/RootLayout/hooks/use-segment-consent'

const RootLayout = () => {
    const { preloaderStore, authStore, libStore } = useContext(StoresContext)
    useDatadogConsent()
    useSegmentConsent()

    const [initIsDone, setInitIsDone] = useState<boolean>(false)
    const { showBoundary } = useErrorBoundary()

    // Handle 503 "Maintenance" Errors From The API
    axiosClient.interceptors.response.use(undefined, (error) => {
        const res = error.response
        if (res?.status === 503) {
            showBoundary(new HttpError(res.data, res.status))
        }
        return Promise.reject(error)
    })

    const initFunc = async () => {
        preloaderStore.openMainPreloader(true)
        try {
            await authStore.checkUserAuthorized()
        } catch (ignore) {
            authStore.clearLoginData()
        }
        await Promise.all([
            libStore.loadLanguages(),
            libStore.loadCountries(),
            libStore.loadWriterRoles(),
            libStore.loadAkaTitleTypes(),
        ]).catch((error) => {
            preloaderStore.openMainPreloader(false)
            showBoundary(error)
        })

        preloaderStore.openMainPreloader(false)
        setInitIsDone(true)
    }

    useEffect(() => {
        initFunc().then()
    }, [])

    return (
        <>
            <HelmetSet />
            <MLCThemeProvider>
                <div className="app">
                    {initIsDone && (
                        <UserInfoHandler>
                            <NavBar />
                            <Outlet />
                            <Footer />
                        </UserInfoHandler>
                    )}
                    <AlertMessage />
                    <Preloaders />
                </div>
            </MLCThemeProvider>
            <ScrollRestoration />
        </>
    )
}

export default observer(RootLayout)
